<script setup>
import MIcon from "@/components/m/MIcon.vue";

defineProps({
  msg: { type: String, default: "" },
  show: { type: Boolean, default: false },
});
</script>

<template>
  <div
    class="btm-toast"
    :class="{ show }"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <MIcon name="check" :size="16" :sw="2.6" style="color: var(--pos)" />{{
      msg
    }}
  </div>
</template>
